import subscriptionService from '../services/subscriptionService';

/**
 * Get subscription bundles action (without dispatch)
 * @returns {Promise<Object>} Bundles result
 */
export const getBundles = async () => {
  try {
    const response = await subscriptionService.getBundles();
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Create subscription action (without dispatch)
 * @param {string} creatorId - Creator ID to subscribe to
 * @param {Object} subscriptionData - Subscription data (bundle ID, returnUrl, etc.)
 * @returns {Promise<Object>} Create subscription result
 */
export const createSubscription = async (creatorId, subscriptionData) => {
  try {
    const response = await subscriptionService.createSubscription(creatorId, subscriptionData);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Check subscription status action (without dispatch)
 * @param {string} creatorId - Creator ID to check subscription status for
 * @returns {Promise<Object>} Check subscription result with subscribed status
 */
export const checkSubscription = async (creatorId) => {
  try {
    const response = await subscriptionService.checkSubscription(creatorId);
    
    if (response.success) {
      // If status is 200, user is subscribed
      const isSubscribed = response.status === 200;
      return { 
        success: true, 
        data: response.data,
        subscribed: isSubscribed,
        status: response.status
      };
    } else {
      return { success: false, error: response.message, subscribed: false };
    }
  } catch (error) {
    // If error occurred but it's expected (like 404), return not subscribed
    return { success: false, error: error.message || 'An unexpected error occurred', subscribed: false };
  }
};

/**
 * Unsubscribe from creator action (without dispatch)
 * @param {string} creatorId - Creator ID to unsubscribe from
 * @param {boolean} isManualRemove - Whether to manually remove the subscription (true) or cancel the subscription (false)
 * @returns {Promise<Object>} Unsubscribe result
 */
export const unsubscribe = async (creatorId, isManualRemove = false) => {
  try {
    const response = await subscriptionService.unsubscribe(creatorId, isManualRemove);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

